import React, { Fragment } from 'react';
import { Pen } from '../icons';
import { currentLanguage, t } from '../../i18n';
import { displayText } from '../../i18n/cards';
import { screenDir, textDir } from '../../i18n/direction';

const fillClass = card => `fill${card.written ? ' fill-written' : ''}`

// An answer's display text, isolated; with no letter it takes the direction of the question. A written card's text
// has no language: lang="" (unknown), so it does not take the question's.
const Answer = ({ card, questionDir, className }) => {
  const { lang, text } = displayText(card)
  return <bdi className={className} lang={lang ?? ''} dir={textDir(text) ?? questionDir}>{text}</bdi>
}

// The question's display text with answer cards dropped into its blanks (the gaps between its parts); answers beyond
// the blanks are listed under it. Written answers get a dashed underline, and with handTag the judge's "written by
// hand" tag. The card reads in the direction of its own words (none: the screen's); each answer is isolated, and the
// tag and the blank's name follow the screen.
export function CardText({ question, answers = [], handTag = false, tag: Tag = 'p' }) {
  const { lang, parts } = displayText(question)
  const extra = answers.slice(parts.length - 1)
  const dir = textDir(parts.join(' '))
  const questionDir = dir ?? screenDir()
  const ui = { dir: screenDir(), lang: currentLanguage() }
  const tagFor = card => handTag && card.written && <> <span className="hand-tag" {...ui}><Pen size={12} width={2.6} />{t('game.handWritten')}</span></>
  return (
    <>
      <Tag className="bc-text" dir={dir} lang={lang}>
        {parts.map((part, i) => (
          <Fragment key={i}>
            {part}
            {i < parts.length - 1 && (answers[i]
              ? <><Answer card={answers[i]} questionDir={questionDir} className={fillClass(answers[i])} />{tagFor(answers[i])}</>
              : <span className="blank" {...ui} aria-label={t('game.blank')}></span>)}
          </Fragment>
        ))}
      </Tag>
      {extra.length > 0 &&
        <ul className="answers-list" dir={dir}>{extra.map((a, i) => <li key={i} className={fillClass(a)}><Answer card={a} questionDir={questionDir} />{tagFor(a)}</li>)}</ul>}
    </>
  )
}

export function CardFoot({ pick }) {
  if (!pick) return null
  return (
    <div className="bc-foot">
      <span className="pick" aria-label={t('game.answersNeeded', { count: pick })}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true"><rect x="4" y="6" width="11" height="15" rx="2"></rect><path d="M9 3h9a2 2 0 0 1 2 2v12"></path></svg>{pick}</span>
    </div>
  )
}
